import { defineComponent as _defineComponent } from 'vue'
import { hasUCConsentBanner } from '@/helpers/tracking';
import { ModalHelper } from '@/helpers/vfm/modal-helper';
import { useLanguageStore } from '@/helpers/composables/useStores';

// LowPriorityComponents already loads the consent-banner chunk. just making sure it's in the same chunk name.

export default /*#__PURE__*/_defineComponent({
  __name: 'ConsentToggleButton',
  setup(__props) {

const ConsentModal = () => import(/* webpackChunkName: "consent-banner" */ '@/components/modals/ConsentModal.vue');

const { webLocale } = useLanguageStore();

function openSettings() {
	if (hasUCConsentBanner(webLocale.value)) {
		window.__ucCmp.showFirstLayer();
	} else {
		ModalHelper.openModal(ConsentModal);
	}
}

return { __sfc: true,ConsentModal, webLocale, openSettings }
}

})